import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { InputField } from '../../../model';
import { VisibilityEnum } from '@urbannex/storethemes';

@Component({
  selector: 'kve-text-field-editor',
  templateUrl: './text-field-editor.component.html',
  styleUrls: ['./text-field-editor.component.scss']
})
export class TextFieldEditorComponent implements OnInit,OnChanges{

@Input() field:InputField;
type:string; //text,header,textarea,email,password
name:string;
readonly:boolean;
value:string;
visible:VisibilityEnum;

@Output() updateField:EventEmitter<InputField> = new EventEmitter<InputField>();

ngOnInit(): void {
  this.name = this.field.name;
  this.type = this.field.type? this.field.type : 'text';
  this.readonly = this.field.readonly? this.field.readonly : false;
  this.value = this.field.value? this.field.value : '';
}
ngOnChanges(changes: SimpleChanges): void {
  if(changes['field']) {
    console.log(this.field)
    this.name = this.field.name;
    this.type = this.field.type ? this.field.type : 'text';
    this.readonly = this.field.readonly ? this.field.readonly : false;
    this.value = this.field.value ? this.field.value : '';
  }
}

}
